(function () {
    'use strict';

    /**
     *
     *
     *
     *
     *
     */
    angular
        .module('trainingDiscrepancy')
        .service('TrainingDiscrepancyService', TrainingDiscrepancyService);

    function TrainingDiscrepancyService(RemoteService, TrainingDiscrepancyRequestFactory, rx, MessageService,
                                        TrainingDiscrepancyAdaptorFactory, CrewingHelper, CrewingAdaptor, EventManagerService) {

        var self = this;
        var model = {
            searchCriteria: TrainingDiscrepancyRequestFactory.getSearchCriteria(),
            trainingList: []
        };
        var trainingLocation = [];
        var trainingCategory = [];
        var airCraftType = [];
        var trainingLocationWithDefault = [];
        var trainingCategoryWithDefault = [];
        var airCraftTypeWithDefault = [];
        self.suggestedCrew = new rx.Subject();


        self.setSearchCriteria = function (passSearch) {
            var search = TrainingDiscrepancyRequestFactory.getSearchCriteria();
            search.aircraftType =!!(passSearch.acType) ? (passSearch.acType.airCraftType == 'ANY' ? null : passSearch.acType.airCraftType ): null;
            search.startPosition = passSearch.startPosition;
            search.pageSize = passSearch.pageSize;
            search.category = !!(passSearch.category) ? (passSearch.category.categoryCode == 'ANY' ? null : passSearch.category.categoryCode) : null;
            search.startDate = passSearch.fromDate;
            search.endDate = passSearch.toDate;
            search.location = !!(passSearch.location) ? (passSearch.location.airPortCode == 'ANY' ? null : passSearch.location.airPortCode) : null;
            model.searchCriteria = search;
        };

        self.setSuggestedCrew = function (suggestedCrew) {
            self.suggestedCrew.onNext(suggestedCrew || []);
        };

        self.loadSuggestedCrew  = function (params) {
            var requestParam = TrainingDiscrepancyRequestFactory.trackingSuggestionRequest(params);
            RemoteService.getSuggestedCrewBySlot(requestParam).then(
                function (response) {
                    self.setSuggestedCrew(TrainingDiscrepancyAdaptorFactory.adaptSuggestedCrewList(response));
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        self.getTrainingDescrepancy = function (successFn, errorFn) {
            RemoteService.searchTrainingDescrepancy(model.searchCriteria).then(
                function (response) {
                    if (response.success) {
                        model.trainingList = response.descrepancyDetails;
                        successFn(model.trainingList);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.getDefaultTrainingLocation = function () {
            var trainingLocation = [];
            trainingLocation.push({
                airPortCode: "ANY",
                airPortName: "ANY"
            });
            return trainingLocation[0];
        };

        self.setTrainingLocation = function (locations) { 
            trainingLocation = [];
            trainingLocationWithDefault = [];
            trainingLocationWithDefault[0] = self.getDefaultTrainingLocation();
            if(!!locations){
            	trainingLocation = locations;
            	trainingLocationWithDefault = trainingLocationWithDefault.concat(locations)
            }
        };

        self.getTrainingLocation = function () {
            return trainingLocation;
        };
        
        self.getTrainingLocationWithDefault = function () {
            return trainingLocationWithDefault;
        };

        self.getDefaultTrainingCategory = function () {
            var trainingCategory = [];
            trainingCategory.push({
                category: "ANY",
                categoryCode: "ANY"
            });
            return trainingCategory[0];
        };

        self.setTrainingCategory = function (category) {
        	trainingCategory = [];
        	trainingCategoryWithDefault = [];
        	trainingCategoryWithDefault[0]  = self.getDefaultTrainingCategory();        	 
            if(!!category){
            	trainingCategory = category;
            	trainingCategoryWithDefault = trainingCategoryWithDefault.concat(category);
            }
        };

        self.getTrainingCategory = function () {
            return trainingCategory;
        };
        
        self.getTrainingCategoryWithDefault = function () {
            return trainingCategoryWithDefault;
        };

        self.getDefaultAircraftType = function () {
            var airCraftType = [];
            airCraftType.push({
            	modelNumber: "ANY",
                airCraftType: "ANY"
            });
            return airCraftType[0];
        };

        self.setAirCraftTypes = function (aircrafts) {
        	airCraftType = [];
        	airCraftTypeWithDefault = [];
        	airCraftTypeWithDefault[0] = self.getDefaultAircraftType(); 
            if(!!aircrafts){
            	airCraftType = aircrafts;
            	airCraftTypeWithDefault = airCraftTypeWithDefault.concat(aircrafts);
            }
        };

        self.getAirCraftTypes = function () {
            return airCraftType;
        };

        self.getAirCraftTypesWithDefault = function () {
            return airCraftTypeWithDefault;
        };
        
        self.getModifiedForDisplay = function (selectedRow) {
            if(selectedRow===null){
                selectedRow = {};
                selectedRow.totalAssTrainee = 0;
                selectedRow.totalTraineeReq = 0;
                selectedRow.totalAssTrainer = 0;
                selectedRow.totalTrainerReq = 0;
                selectedRow.initial = true;
            }

            var traineeNewStatus = false;
            if(selectedRow.initial){
              traineeNewStatus = false;
            } else {
              traineeNewStatus = (selectedRow.totalAssTrainee === selectedRow.totalTraineeReq);
            }

            var trainerNewStatus = false;
            if(selectedRow.initial){
              trainerNewStatus = false;
            } else {
              trainerNewStatus = (selectedRow.totalAssTrainer === selectedRow.totalTrainerReq);
            }

            return {
            	trainee: {
                    assigned:selectedRow.totalAssTrainee,
                    required: selectedRow.totalTraineeReq,
                    status: selectedRow.totalAssign == selectedRow.totalTraineeReq,
                    newStatus: traineeNewStatus
                },
                trainer: {
                    assigned:selectedRow.totalAssTrainer,
                    required: selectedRow.totalTrainerReq,
                    status: selectedRow.totalAssignFrmPattern == selectedRow.totalTrainerReq,
                    newStatus: trainerNewStatus
                }
            }
        };

        /**
         * Assign Training logic
         * @param training
         */
        self.assignTraining = function (discrepancyTraining, crewInfo) {
            var flags = {
                isContinueIllegal: true,
                isUserConfirm: false,
                isExpiryUpdatable: false,
                isIgnoreConflicts: false,
                isIgnoreExpiries: false,
                isIgnoreRequest: false
            };

            var training = TrainingDiscrepancyAdaptorFactory.createTrainingForAssign(discrepancyTraining);
            var trainingData = {};
            trainingData.crewProfileId = crewInfo.crewProfileId;
            trainingData.trainingSlotId = training.trainingSlotId;
            trainingData.trainingSlotProgramId = training.trainingSlotProramId || null;
            trainingData.trainingProgramId = training.trainingProgramId;
            trainingData.trainingProgDetailId = training.trainingProgramDetailId;
            trainingData.assignAsCrewType = crewInfo.crewType;
            trainingData.assignDate = training.startDateZulu;
            trainingData.assignTime = training.startTimeZulu;
            trainingData.courseId = null;
            trainingData.courseTxnId = null;

            var onAssignSuccess = function () {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRAINING_ASSIGN_CREW.DISCREPANCY_TRAINING_ASSIGN_SUCCESS);
            };

            var onCancel = function () {
                training.isAssigned = false;
            };


            var doAssign = function (params, flags) {
                params.continueIllegal = !!flags.isContinueIllegal;
                params.userConfirm = !!flags.isUserConfirm;
                params.expiryUpdatable = !!flags.isExpiryUpdatable;
                params.ignoreConflicts = !!flags.isIgnoreConflicts;
                params.ignoreExpiries = !!flags.isIgnoreExpiries;
                params.ignoreRequest = !!flags.isIgnoreRequest;


                RemoteService.assignTrainerTrainee(params,true).then(
                    function (response) {
                        var adapted = CrewingAdaptor.assignTrainingAdaptor(response);
                        CrewingHelper.assignTrainingActionList(params, adapted, flags, doAssign, onAssignSuccess, onCancel);
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
            };

            doAssign(trainingData, flags);
        };


        self.refineTrainingData = function (refineParam) {
            var filter = {};
            if (!angular.isUndefined(refineParam.acType) && refineParam.acType !== null && refineParam.acType.airCraftType !== 'ANY') {
                filter['fleet'] = refineParam.acType.airCraftType;
            }
            if (!angular.isUndefined(refineParam.category) && refineParam.category !== null && refineParam.category.categoryCode !== 'ANY') {
                filter['trainingCategory'] =  refineParam.category.categoryCode ;
            }
            if (!angular.isUndefined(refineParam.location) && refineParam.location !== null && refineParam.location.airPortCode !== 'ANY') {
                filter['trainingStation'] = refineParam.location.airPortCode;
            }
            return _.filter(angular.copy(model.trainingList), filter);
        };
    }
})();
